import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { Config } from '../../config';
import { AppComponent } from '../app.component';
import { IconsModule } from '../icons.module';
import { NewPasswordComponent } from './components/new-password/new-password.component';
import { NotificationComponent } from './components/notification/notification.component';
import { PasswordStateComponent } from './components/password-state/password-state.component';
import { WindowRefService } from './services/window.service';

@NgModule({
  imports: [
    RouterModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    IconsModule,
    CommonModule,
  ],
  declarations: [AppComponent, NotificationComponent, NewPasswordComponent, PasswordStateComponent],
  exports: [
    AppComponent,
    NotificationComponent,
    NewPasswordComponent,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [Config, WindowRefService],
})
export class SharedModule {}
